<template>
  <el-dialog
    v-if="eventData"
    :title="`${area === 'public' ? '公區' : '私區'}告警回報`"
    :visible.sync="visible"
    :close-on-click-modal="!isChanged"
    :close-on-press-escape="!isChanged"
    :before-close="handleClose"
  >
    <!-- 整個表單 -->
    <div class="content-container">
      <!-- 每個欄位 -->
      <div
        v-for="[en, zh] in Object.entries(eventReportStructure)"
        :key="en"
        class="content-wrapper"
        :class="en"
      >
        <!-- 欄位標題 -->
        <div
          class="key"
          :class="{required:zh === '處理備註'}"
        >
          {{ zh }}
        </div>
        <!-- 欄位內容需個別處理 -->
        <div
          v-if="zh === '處理狀態'"
          class="value"
        >
          <el-select
            v-model="outputForm.status"
            placeholder="請選擇"
          >
            <el-option
              v-for="item in eventStageTypeForReport"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <div
          v-else-if="zh === '處理備註'"
          class="value"
        >
          <el-input
            v-model="outputForm.comment"
            class="formComment"
            type="textarea"
            :rows="4"
            placeholder="請輸入處理備註"
            resize="none"
            :class="{isInvalidStyle:isInvalidStyle}"
            @input="validate"
          />
          <div class="errorMsg">
            {{ invalidType.isEmpty ? '必填欄位不可為空' : '' }}
            {{ invalidType.isOver ? '長度不可超過 200 字' : '' }}
          </div>
        </div>
        <div v-else-if="zh === '告警狀態'" class="value regular" :class="{emergency: eventData['TagLevel'] === 'L4-災害級警報' && !eventData[en], warning: eventData['TagLevel'] === 'L3-高程度警報' && !eventData[en]}">
          {{ eventData[en] ? '正常' : '異常' }}
        </div>
        <div v-else-if="zh === '位置'" class="value regular bold">
          {{ eventData[en] }}
        </div>
        <div v-else class="value regular" :class="{emergency: eventData[en] === 'L4-災害級警報', warning: eventData[en] === 'L3-高程度警報'}">
          {{ eventData[en] }}
        </div>
      </div>
    </div>
    <el-button @click="handleClose">
      取消
    </el-button>
    <el-button
      type="primary"
      :disabled="!isSubmittable"
      @click="handleSubmit"
    >
      送出
    </el-button>
  </el-dialog>
</template>

<script>
import { eventReportStructure, getEventStageTypeForReport } from '../models'
import { EventError } from '../models/error'
import { goToParent, processEventList } from '../utils'
class Form {
  status = null
  comment = null
}
export default {
  components: {
  },
  props: {
  },
  data () {
    return {
      visible: false,
      eventData: null,
      eventReportStructure,
      eventStageTypeForReport: [],
      selectedStatus: null,
      // 判斷資料是否已有異動
      inputForm: new Form(),
      outputForm: new Form(),
      isEdited: false,
      isOpenReporting: false,
      isSubmitting: false,
      area: 'public'
    }
  },
  computed: {
    isChanged () {
      // 狀態有變 or 有輸入文字
      return (this.inputForm.status !== this.outputForm.status) || this.outputForm.comment
    },
    invalidType () {
      const invalidTypeObj = {
        isEmpty: false,
        isOver: false
      }
      if (this.isEdited) {
        // 沒有填寫文字
        invalidTypeObj.isEmpty = (!this.outputForm.comment || this.outputForm.comment?.trim() === '')
        // 填寫超過兩百字
        invalidTypeObj.isOver = this.outputForm.comment?.length > 200
      }
      return invalidTypeObj
    },
    isInvalidStyle () {
      return Object.values(this.invalidType).includes(true)
    },
    isSubmittable () {
      // 需判斷是否有合格文字
      if (this.invalidType.isEmpty || this.invalidType.isOver) return false
      if (this.outputForm.comment) return !!this.outputForm.comment.trim()
      // 初始為 null
      return false
    }
  },
  mounted () {
  },
  methods: {
    // 有異動文字才會觸發此 function，避免初始狀態就是警告
    validate () {
      this.isEdited = true
    },
    async openReportEvent (id, area) {
      if (this.isOpenReporting) return
      this.area = area === '' ? 'public' : area
      this.isOpenReporting = true
      if (id) {
        try {
          const requestAPI = area === 'private' ? apiBaAlert.getPrivateEventById : apiBaAlert.getEventById
          const res = await requestAPI(id)
          this.eventStageTypeForReport = getEventStageTypeForReport(res.data.CanResolveByAdmin)
          // 無此事件
          if (!res.data) throw new EventError()
          // 尚不支援 L0
          if (res.data.TagLevel === 0) throw new EventError(1)
          // 進入到已結案的回報彈窗例外處理（目前只有從推播連結進來才有機會進到這個例外處理）
          if (res.data && res.data.CurrentStageType > 1) throw new EventError(2)
          this.eventData = processEventList([res.data])[0]
          this.inputForm.status = this.eventData.CurrentStageType
          this.outputForm.status = this.eventData.CurrentStageType
          this.visible = true
        } catch (error) {
          const message = error.name === 'EventError' ? error.message : '無此事件'
          this.$confirm(message, {
            confirmButtonText: '確定',
            showCancelButton: false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
          }).finally(() => {
            // 取消或確定則關閉
            this.resetDataAndSetting()
            goToParent(this.$route, this.$router)
          })
        }
      }
      this.isOpenReporting = false
    },
    resetDataAndSetting () {
      // 設定初始化
      this.visible = false
      this.isEdited = false
      // 將資料初始化
      this.eventData = null
      this.inputForm = new Form()
      this.outputForm = new Form()
    },
    handleClose (isGoToParent = true) {
      // 如果是切換路由導致關閉就不要返回根路由
      // 如果是從詳情（公區 / 私區）的路由點擊「前往回報」以開啟回報，則關閉回報的時候不返回根路由、關閉詳情時才會返回根路由
      if (this.$route.name === 'eventDetailById' || this.$route.name === 'privateEventDetailById') isGoToParent = false
      if (this.isChanged) {
        // 如果有編輯過
        this.$confirm('您的資料尚未儲存，仍要離開請按確定', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 確定則關閉
          this.resetDataAndSetting()
          if (isGoToParent) {
            goToParent(this.$route, this.$router)
          }
        }).catch(() => {})
      } else {
        // 如果沒編輯過
        // 直接關閉
        this.visible = false
        this.isEdited = false
        if (isGoToParent) {
          goToParent(this.$route, this.$router)
        }
      }
    },
    async handleSubmit () {
      if (this.isSubmitting) return
      this.isSubmitting = true
      try {
        const id = this.eventData.EventId
        const newStageType = this.eventStageTypeForReport.indexOf(this.outputForm.status)
        const newRemark = this.outputForm.comment
        const data = {
          stageType: newStageType,
          remark: newRemark
        }
        const updateRowData = {
          EventId: this.eventData.EventId,
          CurrentStageType: newStageType,
          CurrentStageRemark: newRemark,
          StageList: [
            {
              Type: newStageType,
              Remark: newRemark,
              Reporter: JSON.parse(localStorage.getItem('loginUserInfo')).AdminName || '',
              ReportedTime: new Date().toISOString()
            },
            ...this.eventData.StageList
          ]
        }
        const requestAPI = this.area === 'private' ? apiBaAlert.reportPrivateEvent : apiBaAlert.reportEvent
        await requestAPI(id, data)
        this.$message({
          message: '回報成功',
          type: 'success'
        })
        // 不需流量的本地端即時更新
        const subPath = this.$route.path.split('/')[2].toLowerCase()
        console.log(subPath)
        if (subPath === 'event' || subPath === 'privateevent') {
          this.$emit('localUpdateEventRow', updateRowData)
          this.$emit('closeEventDetail', updateRowData)
        } else if (subPath === 'management') {
          this.$emit('localUpdateTagDetail', updateRowData)
        }
      } catch (error) {
        console.log(error)
        if (error.response.status === 400) {
          this.$confirm('此事件已結案', {
            confirmButtonText: '確定',
            showCancelButton: false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
          }).finally(() => {
            // 取消或確定則關閉
          })
        }
      } finally {
        this.resetDataAndSetting()
        goToParent(this.$route, this.$router)
        this.isSubmitting = false
      }
    }
  }
}
</script>

  <style lang="scss" scoped>
.required {
  position: relative;
  @include redStar();
}
::v-deep .el-dialog {
  @include basicDialog();

  .content-container {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 20px;
    .content-wrapper {
      text-align: start;
      display: flex;
      min-height: 50px;
      height: auto;
      flex: 0 0 50%;

      .key {
        color: $mainFontColor;
        $key_width: 120px;
        flex: 0 0 $key_width;
        $key_size: 17px;
        font-weight: bold;
        font-size: $key_size;
      }
      .value {
        flex: 0 1 100%;
        padding-bottom: 20px;
        .el-dropdown-link {
          cursor: pointer;
        }
        .formComment.isInvalidStyle {
          position: relative;
          textarea {
            border-color: $dangerColor;
          }
        }
        .errorMsg {
          padding-top: 5px;
          color: $dangerColor;
        }
        &.bold {
          font-weight: bold;
        }
      }
      &.CurrentStageType,
      &.CurrentStageRemark {
        flex: 0 1 100%;
      }
    }
  }
}
</style>
